import { ContainerType, UnitOfMeasurement } from "@/types";

export const pluralizeUnit = (
  unit: UnitOfMeasurement | ContainerType
): string => {
  if (unit === UnitOfMeasurement.ML) return unit;
  if (unit === UnitOfMeasurement.BOX) return unit + "es";
  return unit + "s";
};
